/*
 * Copyright © 2015-2020 Serenova, LLC. All rights reserved.
 */

/*
 * MessageContent Messages
 *
 * This contains all the text for the MessageContent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  otherInteractionMessage: {
    id: 'app.components.messageContent.otherInteractionMessage',
    defaultMessage: 'Attachment in other interaction',
  },
  fileNotFoundInTranscript: {
    id: 'app.components.messageContent.fileNotFoundInTranscript',
    defaultMessage: 'File not found in transcript',
  },
  notSupported: {
    id: 'app.components.messageContent.notSupported',
    defaultMessage: 'Not supported',
  },
});
